import type { CreateOrUndoEntityMergeResponse } from '@clsplus/api-types/entity-merge'

import { requestApiJsonOrThrow } from '../request-handler'

export function undoMergeRequest(mergeRequestId: string): Promise<CreateOrUndoEntityMergeResponse> {
  return requestApiJsonOrThrow<CreateOrUndoEntityMergeResponse>(`entity-merge/merge-requests/${mergeRequestId}/undo`, {
    method: 'PATCH',
  })
}
